import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonComponentsModule } from './components/common-components.module';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        CommonComponentsModule
    ]
})
export class AppCommonModule { }
